module.exports = __webpack_public_path__ + "img/3.172a1f55.jpg";